let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bvJbg")).then(() => parcelRequire('2e4H4'));